import {computed} from 'mobx';

import {BaseViewModel} from "../../../infrastructure/models/base-view-model";
import {VoteDomainModel} from "../../../domain/full-game/models/prediction/option/vote/vote.domain-model";

export class PredictionsWidgetVoteViewModel extends BaseViewModel {
  domainModel: VoteDomainModel;

  @computed get count(): Number {
    return this.domainModel.count;
  }

  get key(): Number {
    return this.domainModel.key;
  }

  @computed get percentage(): String {
    const percentage: String = `${this.domainModel.percentage}%`;

    return percentage;
  }

  @computed get percentageValue(): String {
    return this.domainModel.percentage;
  }
}